var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-payment",staticStyle:{"min-height":"100vh"}},[_c('div',{staticClass:"logo text-center bg-transparent"},[_vm._t("logo",function(){return [_c('img',{attrs:{"src":require("@/assets/images/bulle-payment.png"),"alt":""}})]})],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }